import { cachedFetch, endpointWrapper } from 'utils/api/meta.api';

/**
 * Which fetcher answers for a data source.
 *
 * Every source uses the default: `endpointWrapper` behind `cachedFetch`, which
 * de-duplicates concurrent identical requests and caches the response until the
 * `last_updated` / `app_version` headers change.
 *
 * A source served from somewhere else registers here rather than adding a named
 * branch to whichever shared module happens to reach it. Adapters must be
 * signature-compatible with `endpointWrapper`: `{ domain, data, params,
 * controller, method }` in, parsed JSON out, a rejected `Error` carrying
 * `.status`.
 *
 * Keyed by API name (`apiDataSource`), not by the SCREAMING_CASE key, because
 * the callers that need a transport are the ones building a request URL.
 *
 * Kept out of `utils/dataSources/index.js` so that stays a leaf importing only
 * `@/config/constants` — this module imports the api layer, and the descriptor
 * is imported by `utils/entities` and `utils/metrics`.
 */
const TRANSPORTS = {};

const defaultTransport = cachedFetch(endpointWrapper);

export const transportFor = (apiName) =>
    TRANSPORTS[apiName] || defaultTransport;
